import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { CCOButton } from '../../util/Components.js';
import { get, update, remove, listenTo } from '../../util/Utility';
import 'react-datepicker/dist/react-datepicker.css';

// Turns "_" and "-" into spaces and capitalizes each word
// e.g. Turns "payment_method" into "Payment Method"
function formatDataName(name) {
  return name.replace(/[_-]+/g, " ").replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}

class RSVPView extends Component {

  constructor(props) {
    super(props);

    this.state = {
      rsvps: [],
      paid: {},
      loaded: false
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.show && !this.props.show && !this.state.loaded) {
      this.loadData(newProps);
    }
  }

  loadData(newProps) {
    listenTo("events/" + newProps.event.key + "/rsvp", this, data => {
      this.setState({rsvps: [], loaded: true}, () => {
        Object.keys(data).forEach(item => {
          get("profiles/" + newProps.event.ministryID + "/" + newProps.event.key + "/" + item, this, null, null, false).then(data => {
            if (!data.removed) {
              var obj = this.state.rsvps;
              obj.push({...data, key: item});
              this.setState({rsvps: obj});

              if (newProps.event.action === "register") {
                get("payments/" + newProps.event.ministryID + "/" + newProps.event.key + "/" + item, this, null, null, false).then(data => {
                  var obj = this.state.paid;
                  obj[item] = !data.awaiting_payment;
                  this.setState({paid: obj});
                });
              }
            }
          });
        });
      });
    }, null, null, false);
  }

  remove(uid) {
    update("profiles/" + this.props.event.ministryID + "/" + this.props.event.key + "/" + uid, this, {removed: true});
    update("payments/" + this.props.event.ministryID + "/" + this.props.event.key + "/" + uid, this, {removed: true});
    remove("events/" + this.props.event.key + "/rsvp/" + uid, this);
  }

  render() {
    var divStyle = {
      maxWidth: 900,
      color: 'black'
    };

    var otherHeaders = this.props !== undefined && this.props.event !== undefined && this.props.event.hasOwnProperty('rsvpFormFields') ? Object.keys(this.props.event.rsvpFormFields).map(otherKey => <th key={otherKey}>{formatDataName(otherKey)}</th>) : null;

    var rows = this.state.rsvps.map((item, i) => {
      const { full_name, email, key, ...other } = item;
      let otherItems = this.props.event.hasOwnProperty('rsvpFormFields') ? Object.keys(this.props.event.rsvpFormFields).map(otherKey => other.hasOwnProperty(otherKey) ? <td key={otherKey}>{other[otherKey]}</td> : <td key={otherKey} />) : null;
      return <tr key={i}><td>{full_name}</td><td>{email}</td>{otherItems}{this.props !== undefined && this.props.event !== undefined && this.props.event.action === "register" ? (this.state.paid.hasOwnProperty(item.key) ? <td>&#10004;</td> : <td>X</td>) : null}<td><button className="blueButton" onClick={() => this.remove(key)}>Remove</button></td></tr>
    });

    return (
      <div style={divStyle}>
        <Modal show={this.props.show} onHide={this.props.done} bsSize={otherHeaders && otherHeaders.length > 2 ? "large" : "medium"}>
          <Modal.Header closeButton>
            <Modal.Title>Event {this.props.event.action === "rsvp" ? "RSVPs" : "Registrations"} for {this.props.event.title}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {rows.length === 0 ?
              <center><p>No one has signed up yet, go tell people about your event!</p></center>
              :
              <table className="rsvpTable">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    {otherHeaders}
                    {this.props.event.action === "register" && <th>Paid</th>}
                    <th style={{color: 'red'}}>Remove</th>
                  </tr>
                </thead>
                <tbody>
                  {rows}
                </tbody>
              </table>
            }
          </Modal.Body>

          <Modal.Footer>
            <center>
              <div style={{width: 200}}>
                <CCOButton onClick={this.props.done} text="Done" type="primary" />
              </div>
            </center>
          </Modal.Footer>

        </Modal>
      </div>
    );
  }
}

export default RSVPView;



/** WEBPACK FOOTER **
 ** ./src/ministry/events/RSVPView.js
 **/